<template>
  <div class="page">
    <div class="wrap">
      <div class="card">
        <div class="Title">密码修改</div>
        <div class="form">
          <a-form
              id="formUpdate"
              :form="form"
              ref="formUpdate"
              @submit="handleSubmit"
              :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }"
            >
            <div class="container">

              <a-form-item label="旧密码">
                <a-input
                  class="cus-input"
                  type="password"
                  autocomplete="false"
                  placeholder="请输入旧密码"
                  v-decorator="[
                    'oldPwd',
                    {
                      rules: [{ required: true, message: '请输入旧密码' }],
                      validateTrigger: 'blur',
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item label="新密码">
                <a-input
                  class="cus-input"
                  type="password"
                  autocomplete="false"
                  placeholder="请输入新密码"
                  v-decorator="[
                    'newPwd',
                    {
                      rules: [{ required: true, message: '请输入新密码' }],
                      validateTrigger: 'blur',
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item label="确认密码">
                <a-input
                  class="cus-input"
                  type="password"
                  autocomplete="false"
                  placeholder="请再次输入密码"
                  v-decorator="[
                    'psdAgain',
                    {
                      rules: [{ required: true, message: '请再次输入密码' }],
                      validateTrigger: 'blur',
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item :wrapper-col="{ span: 15, offset: 8 }">
                <div class="tip">{{tip}}</div>
              </a-form-item>

              <a-form-item :wrapper-col="{ span: 8, offset: 8 }">
                <a-button
                  type="primary"
                  size="large"
                  block
                  htmlType="submit"
                  class="action-button"
                  >确认修改</a-button
                >
              </a-form-item>

            </div>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updatePwd, updatePwdRule, logOut } from '@/api/api';


export default {
  name: "updatePwd",
  data() {
    return {
      form: this.$form.createForm(this),
      rule: '',
      tip: '',
      prompt: '',
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if(values.newPwd){
          const regPwd = eval(`/${this.rule}/`);
          if (!regPwd.test(values.newPwd)) {
            this.$message.error({
              content: this.prompt,
            });
            return;
          }
        }
        if (values.newPwd && values.oldPwd) {
          if (values.oldPwd == values.newPwd) {
            this.$message.error('新密码需与旧密码不同！');
            return;
          }
        }
        if(values.psdAgain){
          if (values.psdAgain != values.newPwd) {
            this.$message.error('两次输入密码不一致，请重新输入！');
            return;
          }
        }
        if (!err) {
          updatePwd({
            oldPwd: values.oldPwd.trim(),
            newPwd: values.newPwd.trim(),
          }).then(res => {
            if (res.code == 0) {
              this.form.resetFields();
              // this.$message.success(res.msg)
              this.toLogout()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      });
    },
    toLogout() {
      const _this = this
      this.$confirm({
        title: '提示',
        content: '密码修改成功，请使用新密码进行登录！',
        onOk () {
          logOut().then(res => {
            if (res.code == 0) {
              // _this.$message.success(res.msg);
              // _this.$message.success('注销登录成功');
              const uvCode = localStorage.getItem("uvCode")
              localStorage.clear();
              setTimeout(() => {
                _this.$router.push({
                  name: "Login",
                  query: {
                    uvCode: uvCode
                  }
                });
              }, 1000)
            } else {
              _this.$message.error(res.msg);
            }
          })
        },
        onCancel () {
        }
      })
    },
    getPwdRule () {
      updatePwdRule().then(res => {
        this.rule = res.regular;
        this.tip = res.pwdZcText;
        this.prompt = res.prompt;
      })
    }
  },
  mounted() {
    this.form.resetFields();
    this.getPwdRule()
  },
}
</script>

<style lang="less" scoped>
.page{
  background-color: #F5F5F5;
}
.wrap{
}
.card{
  background-color: #ffffff;
  min-height: 448px;
  border-radius: 4px;
  padding: 0 20px;
  .Title{
    padding: 16px 0 12px;
    border-bottom: 1px solid #F5F5F5;
    font-size: 16px;
    color: #000000;
    font-weight: 600;
  }
  .form{
    margin-top: 48px;
  }
  .action-button{
    // margin-top: 16px;
  }
}
.tip{
  font-size: 12px;
  color: #FF4747;
}
</style>